module.exports = "{\n  \"plugins\": {\n    \"@brightinteractive/bright-js-framework/plugins/graphql\": {},\n    \"@brightinteractive/bright-js-framework/plugins/graphql-server\": {}\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!../examples/graphql-server/luminant.json
// module id = 665
// module chunks = 249879837935775